import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import Clipboard from 'clipboard';

import Analytics from 'APP_ROOT/services/analytics';
import { ModalLoadingPage } from '../../common/loadingPage';
import { strings } from '../../../localization';



export default class TripSharingModal extends PureComponent {

    constructor(props) {

        super(props);

        this.state = {
            copyBtnText: strings.action_copy_link
        };
    }

    componentDidMount() {

        Analytics.modalView('/tripSharingModal');
    }

    componentDidUpdate() {

        var cb = new Clipboard('#copyTripLinkBtn');
    }

    copyTripShareLink = () => {

        this.setState({
            copyBtnText: strings.copied
        });
    }

    render() {


        if (this.props.modalLoading) {

            return (
                <div className="container-fluid">
                    <div className="row">

                        <ModalLoadingPage />

                        <div className="col-12 action-btns text-right">
                            <button onClick={this.props.closeTripShareModal} className="close-btn btn btn-outline-blue">{strings.action_close}</button>
                        </div>
                    </div>
                </div>
            );
        } else {

            return (
                <div className="container-fluid">
                    <div className="row">
                        <div className="col-12 content-group">
                            <h2>{strings.formatString(strings.share_trip_title)}</h2>
                            <p className="no-margin">{strings.formatString(strings.share_trip_message)}</p>
                        </div>

                        <div className="col-12 content-group">
                            <a id="tripShareUrl" target="_blank" rel="noopener noreferrer" href={this.props.tripShareUrl}>{this.props.tripShareUrl}</a><button onClick={this.copyTripShareLink} className="btn btn-outline-blue btn-sm" id="copyTripLinkBtn" data-clipboard-target="#tripShareUrl">{this.state.copyBtnText}</button>
                        </div>

                        <div className="col-12 action-btns text-right">
                            <button onClick={this.props.closeTripShareModal} className="close-btn btn btn-outline-blue">{strings.formatString(strings.app_close)}</button>
                        </div>
                    </div>
                </div>
            );
        }
    }
}

TripSharingModal.propTypes = {
    modalLoading: PropTypes.bool,
    closeTripShareModal: PropTypes.func.isRequired,
    tripShareUrl: PropTypes.string,
    errorMessage: PropTypes.string
};
